var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "https://lottiefiles.com/animations/groovy-gift-2lQC8FNmzd",
    clipPath: "url(#clip0_10139_3796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10139_3796",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_4397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70 0H0V70H70V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10139_3796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.9746 25.1836C37.9746 25.1836 45.1636 17.2567 50.0654 19.2239C54.9671 21.1912 55.9401 33.4575 38.8855 29.0022L37.9746 25.1836Z",
    fill: "#FFC215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.1742 24.1387C49.557 26.5085 44.1145 26.9813 41.829 27.0741C41.787 26.8245 41.7844 26.6221 41.8491 26.5147C42.1659 25.9854 45.7875 25.861 45.5757 25.0821C45.3657 24.304 43.2202 24.8333 41.955 25.1756C40.6897 25.5179 39.9801 23.2462 39.9784 23.2393C38.7569 24.3226 37.9746 25.1841 37.9746 25.1841L38.8855 29.0027C39.4971 29.1626 40.0807 29.2963 40.6469 29.4145V29.4161C40.6801 29.423 40.7125 29.4284 40.7466 29.4354C40.9146 29.4702 41.08 29.5011 41.2445 29.532C41.3932 29.5606 41.542 29.5884 41.6881 29.6131C41.8272 29.6371 41.9646 29.6595 42.102 29.6811C42.2647 29.7066 42.4257 29.7305 42.5841 29.753C42.6497 29.7615 42.7171 29.7738 42.781 29.7823L42.7792 29.7785C50.6149 30.8053 53.2854 27.3978 53.1742 24.1387Z",
    fill: "#DDA700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.026 25.1836C32.026 25.1836 24.8379 17.2567 19.9361 19.2239C15.0344 21.1912 14.0605 33.4575 31.1151 29.0022L32.026 25.1836Z",
    fill: "#FFC215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.026 25.1841C32.026 25.1841 31.2429 24.3226 30.0223 23.2393C30.0205 23.2462 29.31 25.5179 28.0457 25.1756C26.7795 24.8333 24.634 24.304 24.424 25.0821C24.2132 25.8602 27.8348 25.9854 28.1515 26.5147C28.2163 26.6221 28.2128 26.8245 28.1717 27.0741C25.8853 26.9813 20.4428 26.5085 16.8255 24.1387C16.7153 27.3978 19.3849 30.8053 27.2205 29.7785L27.2197 29.7823C27.2835 29.7738 27.3509 29.7615 27.4148 29.753C27.574 29.7305 27.735 29.7066 27.8987 29.6811C28.0352 29.6595 28.1725 29.6371 28.3117 29.6131C28.4578 29.5884 28.6065 29.5606 28.7553 29.532C28.9207 29.5011 29.0852 29.4702 29.254 29.4354C29.2882 29.4284 29.3197 29.423 29.3538 29.4161V29.4145C29.919 29.2963 30.5027 29.1626 31.1143 29.0027L32.026 25.1841Z",
    fill: "#DDA700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.899 29.9707H34.1018C32.0762 29.9707 30.4355 28.5212 30.4355 26.7324C30.4355 24.9445 32.0762 23.4941 34.1018 23.4941H35.899C37.9238 23.4941 39.5653 24.9445 39.5653 26.7324C39.5653 28.5212 37.9238 29.9707 35.899 29.9707Z",
    fill: "#FFC215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.5653 27.9424C39.5653 29.0628 38.5398 29.9699 37.2754 29.9699H32.7254C31.4602 29.9699 30.4355 29.0628 30.4355 27.9424H39.5653Z",
    fill: "#DDA700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M50.5907 56.0003H19.4092C17.4763 56.0003 15.9092 54.6164 15.9092 52.9096V32.0487C15.9092 30.3419 17.4763 28.958 19.4092 28.958H50.5907C52.5236 28.958 54.0907 30.3419 54.0907 32.0487V52.9096C54.0907 54.6164 52.5236 56.0003 50.5907 56.0003Z",
    fill: "#FF334A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M54.0907 37.0703H15.9092V40.5566H54.0907V37.0703Z",
    fill: "#E10025"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.5 37.0702H17.5C15.5671 37.0702 14 35.6863 14 33.9795V32.0478C14 30.3417 15.5671 28.957 17.5 28.957H52.5C54.4329 28.957 56 30.3417 56 32.0478V33.9795C56 35.6863 54.4329 37.0702 52.5 37.0702Z",
    fill: "#FF334A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38.6165 56.0004H31.3838V37.0713H38.6165V56.0004Z",
    fill: "#FFC215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M38.6165 37.0703H31.3838V40.5566H38.6165V37.0703Z",
    fill: "#DDA700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M29.2061 28.957H40.7946V37.0702H29.2061V28.957Z",
    fill: "#FFC215"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10139_3796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.fb371d146978d51d085f4ca5c084e2f5.svg";
export { ForwardRef as ReactComponent };